import React, { useEffect } from 'react';

import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';

import AddIcon from '@mui/icons-material/Add';
import RefreshIcon from '@mui/icons-material/Refresh';
import { Box, IconButton, Tooltip, Typography } from '@mui/material';
import { makeStyles } from '@mui/styles';

interface Props {
  setIsAuthorisedLoading: (params: any) => any;
  setIsPendingLoading: (params: any) => any;
  onRefreshPatients: () => void;
}

const useStyles = makeStyles((theme: any) => ({
  root: {
    display: 'flex',
    justifyContent: 'space-between',
    marginRight: 30,
  },
  personActions: {
    display: 'flex',
  },
}));

export const PatientsHeader: React.FC<Props> = ({ onRefreshPatients }) => {
  const { t } = useTranslation('patients');
  const classes = useStyles();
  let navigate = useNavigate();

  useEffect(() => {
    onRefreshPatients();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const handleAddPatient = () => {
    navigate('/dashboard/patients/add');
  };
  return (
    <div className={classes.root}>
      <Typography variant="h4" component="h4">
        {t('title')}
      </Typography>

      <Box className={classes.personActions}>
        <Tooltip title={t('refreshTooltip')}>
          <IconButton
            aria-label="refresh"
            size="large"
            onClick={onRefreshPatients}
          >
            <RefreshIcon fontSize="inherit" />
          </IconButton>
        </Tooltip>
        <Tooltip title={t('addTooltip')}>

          <IconButton aria-label="add" size="large" onClick={handleAddPatient}>
            <AddIcon fontSize="inherit" />
          </IconButton>
        </Tooltip>
      </Box>
    </div>
  );
};

export default PatientsHeader;
